import { render, staticRenderFns } from "./GJHeader.vue?vue&type=template&id=00f4503c&"
import script from "./GJHeader.vue?vue&type=script&lang=js&"
export * from "./GJHeader.vue?vue&type=script&lang=js&"
import style0 from "./GJHeader.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports